export default "__VITE_ASSET__31ab89d8__"